
import Logo from "../Assets/Aviator/Logo.png";
import gamebg from "../Assets/Aviator/gamebg1.svg";
import plane from "../Assets/Aviator/sprite4.png";
import GameLoader from "../Assets/Aviator/GameLoader.png";
import BlurryBg from "../Assets/Aviator/blurrybg.png";
import curve from "../Assets/Aviator/curve1.png";
import horDots from "../Assets/Aviator/horDots.png";
import verDots from "../Assets/Aviator/verDots.png";
import sprite2 from "../Assets/Aviator/sprite2.png";
import sprite3 from "../Assets/Aviator/sprite3.png";
import Inc from "../Assets/Aviator/Inc.png";
import Dec from "../Assets/Aviator/Dec.png";
import bgImg from "../Assets/Plinko/BackGround.png";
export const AviatorImages = {
  Logo,
  gamebg,
  plane,
  GameLoader,
  BlurryBg,
  curve,
  horDots,
  verDots,
  sprite2,
  sprite3,
  Inc,
  Dec,
  bgImg
};
